<div class="spinner" [style.fontSize]="size">
    @let blades = ' '.repeat(12).split('') ;
    @for (_ of blades; track $index) {
        <div class="spinner-blade" [style.backgroundColor]="color"></div>
    }
</div>
